import MortgageeRequest from './MortgageeRequest';

export default class MortgageeRequestWithStatusAndId extends MortgageeRequest {
	public id: number | null = null;
	public mortgageeGuid: string | null = null;
	public status: string | null = null;
	public statusMessage: string | null = null;

	public constructor() {
		super();
	}
}